import * as React from 'react';
import MyMarker from '../../components/Marker';
import { ObjectCard } from '../../components/ObjectCard';
import { UpdatedTs } from '../../util/FormattingUtils';
import { Box, Typography, Stack, Divider } from '@mui/material';


const endpoint = "train_crossings";

const showCardContent = (obj) => { return true }

const getIcon = (icon, zoom) => {
    let url = "/mapicons/train/RailRoadCrossing_green.png";
    if(icon.blocked) {
        url = "/mapicons/train/RailRoadCrossing_red.png"
    }
    let size = new window.google.maps.Size(30, 30);
    let anchor = new window.google.maps.Point(15, 15);
    if (zoom < 11 && zoom > 8) {
        size = new window.google.maps.Size(15, 15);
        anchor = new window.google.maps.Point(9, 9);
    } else if(zoom <= 8) {
        size = new window.google.maps.Size(10, 10);
        anchor = new window.google.maps.Point(5, 5);
}
    return {
        url: url,
        anchor: anchor,
        scaledSize: size
    };
}

const TCMarker = (props) => {
    const currentZoom = props.currentZoom;
    const icondef = getIcon(props.icon, currentZoom);
    return (
        <MyMarker {...props} icondef={icondef} />
    )
}
    
const InfoWindow = (props) => {
    const obj = props.icon;
    const iconUrl = obj.blocked ? "/mapicons/train/RailRoadCrossing_red.png" : "/mapicons/train/RailRoadCrossing_green.png";
    return(
        <Box className="map-popup-text" sx={{ maxWidth: 300, '& .infoWindow': { border: 'none' } }}>
            <Stack spacing={1.5} sx={{ minWidth: 200 }}>
                <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <img src={iconUrl} alt="Train Crossing" style={{ width: 24, height: 24 }} />
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            {obj.startPoint.route}
                        </Typography>
                    </Box>
                    <Typography variant="body2" sx={{ ml: '32px' }}>
                        Train Crossing
                    </Typography>
                </Box>
                <Stack spacing={1}>
                    <Typography variant="body2">
                        • Status: {obj.blocked ? "Blocked" : "Clear"}
                    </Typography>
                </Stack>
                <Divider />
                {obj.timestamp && 
                    <Typography variant="caption">
                        Updated: <UpdatedTs value={obj.timestamp} />
                    </Typography>
                }
            </Stack>
        </Box>
    )
}

export default {
    name: 'Crossings',
    label: 'Train Crossing #',
    marker: TCMarker, 
    showOnMap: true, //show on map layer filter
    mapLayerIcon: "/mapicons/train/RailRoadCrossing_red.png",
    showOnSidebar: false,
    sideBarCard: ObjectCard,
    endpoint: endpoint,
    defaultOn: false,
    updateDelay: 0,
    showCardContent: showCardContent,
    infoWindow: InfoWindow,
    publishLayer: "tasWebapp.traincrossingicons.enable",
    resizeOnZoom: true
}